module.exports = __webpack_public_path__ + "static/media/team_members.1e54bfc2.png";